import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MdAccessTime } from 'react-icons/md';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AutoApprovalPeriodUpdateForm = () => {
  const [campaign, setCampaign] = useState(null);
  const [autoApprovalPeriod, setAutoApprovalPeriod] = useState(null);
  const [loading, setLoading] = useState(true);

  const pathParts = window.location.pathname.split('/');
  const id = pathParts[pathParts.length - 1];

  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        const res = await axios.get(`/compaign/getAutoApprovalPeriod/${id}`);
        setCampaign(res.data);
        setAutoApprovalPeriod(res.data.autoApprovalPeriod);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching campaign:', error);
        toast.error('Failed to load campaign');
        setLoading(false);
      }
    };

    fetchCampaign();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.patch(`/compaign/updateAutoApprovalPeriod/${id}`, {
        autoApprovalPeriod,
      });
      toast.success(' Auto-Approval Period updated successfully');
    } catch (error) {
      console.error('Error updating autoApprovalPeriod:', error);
      toast.error(' Error updating autoApprovalPeriod');
    }
  };

  if (loading) return <p className="text-center text-primary">Loading...</p>;
  if (!campaign) return <p className="text-center text-danger">Campaign not found</p>;

  return (
    <form
      onSubmit={handleSubmit}
      className="d-flex align-items-center gap-3 bg-light border rounded shadow-sm px-2 py-1"
      style={{ minWidth: '320px' }}
    >
      <MdAccessTime size={24} className="text-primary" />
      <label className="form-label mb-0 fw-semibold me-2">Auto-Approval:</label>

      <select
  className="form-select w-auto"
  value={autoApprovalPeriod ?? ''}
  onChange={(e) => setAutoApprovalPeriod(Number(e.target.value))}
  required
  disabled={autoApprovalPeriod === null}
>

        <option value={5}>5 Days</option>
        <option value={7}>7 Days</option>
        <option value={10}>10 Days</option>
        <option value={14}>14 Days</option>
      </select>

      <button type="submit" className="btn btn-primary">
        Update
      </button>
    </form>
  );
};

export default AutoApprovalPeriodUpdateForm;

